(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .controller('SSAreaController', SSAreaController);

    SSAreaController.$inject = ['SSArea'];

    function SSAreaController(SSArea) {

        var vm = this;

        vm.sSAreas = [];

        loadAll();

        function loadAll() {
            SSArea.query(function(result) {
                vm.sSAreas = result;
                vm.searchQuery = null;
            });
        }
    }
})();
